export { default as SectionViewRenderer } from './hocs';
